import { ViewTemplateForClient } from '@frontend/vanilla/core';

import { ClientContentData } from '../models/models';

export class CategoryTemplate {
    title: string;
    id: string;
    children?: any;
}

export class ContactInitDataResponse {
    clientContentData: ClientContentData;
    categoriesList: CategoryItem[];
    userAgent: string;
    additionalTextContent: any;
    contactInfoText: any;
    contactInfoTextCountries: any;
    contactPageLinks: LinkTemplateItem[];
    contactPageLinkButtons: LinkTemplateItem[];
    faqPageLinks: LinkTemplateItem[];
    deviceType: string;
    renderCategories: boolean;
    isUSNJLabel: boolean;
    newCategoriesList: any[];
    oldCategoriesList: any[];
    enableHelpAndContactPage: boolean;
    isVipUser: boolean;
    contactOptions: any;
    showCustomerServiceMessage: boolean;
    postLoginRedirectOverrideContidionUsnj: boolean;
    emailVerificationEnabled: boolean;
    helpContactContent: ClientContentData;
    showDocumentUploadOption: boolean;
    showNewDocumentUploadOption: boolean;
    ShowContactAddress: boolean;
    documentUploadContent: any;
    enableHelpAndContactPhase2: boolean;
    enableHelpAndContactPhase3: boolean;
    enablePokerNavigateBack: boolean;
    enableLoginButtonPhase3: boolean;
    showSearchInPhase3: boolean;
    popularArticleNames: string[];
    attributes?: { [key: string]: string };
    messages?: { [key: string]: string };
    useNewHelpAndContactTemplate: boolean;
    playerPriority: string;
    helpAndContactUxCleanUpEnabled: boolean;
    isTwitterOptionActive: boolean;
    enableSitecoreControlForOptions: boolean;
    landingPage: any;
    csMessage: ViewTemplateForClient;
    zendesk: boolean;
    enableGreeceComplaintForm: boolean;
    isLoadingIndicatorEnabled: boolean;
    isEmergencyMsgPlacedTop: boolean;
    enableChatHistory: boolean;
    chatHistory: ClientContentData;
    chatHistoryContent: ClientContentData;
    enableColorForCategories: boolean;
    isNewDobEnabled: boolean;
    allowedFileTypes: string;
    showContactOptionsBySource: { [key: string]: string[] };
    isInstagramOptionActive: boolean;
    loginKeywords: string[];
    enableBackIcon: boolean;
    enableContactOptionsTile: boolean;
    promoContent: ClientContentData;
    enablePromoCTA: boolean;
    enableDragAndDrop?: boolean;
    contactusTilePosition: string;
}

export class Categories {
    categoryId: string;
    subCategoryId: string;
}

export class CategoryItem {
    key: string;
    category: any;
}

export class LinkTemplateItem {
    key: string;
    linkItems: any;
}

export class ContactData {
    birthData: Date | null;
    firstName: string | null;
    firstNameAutoFilled: string | null;
    surname: string | null;
    surnameAutoFilled: string | null;
    email: string | null;
    emailAutoFilled: string | null;
    deviceType: string | null;
    deviceTypeAutoFilled: string | null;
    message: string;
    category?: string | null;
    subCategory?: string | null;
    supportEmailAddress: string;
    userAgent: string;
    screenshot: any;
}

export class HelpPageContactData {
    birthData: Date | null = null;
    firstName: string = '';
    surname: string = '';
    email: string | null = '';
    emailAutoFilled: string = '';
    message: string = '';
    category: string = '';
    document: any = null;
    isCPCCUser: boolean = false;
    fathername: string = '';
    passportnumber: string = '';
    permanentAddress: string = '';
    dateofincident: Date | null = null;
    supportDocument: any = null;
    backDocument: any = null;
    passportDocument: any = null;
}

export class HelpAndContactData {
    showButtons: boolean = false;
    showEmailScreen: boolean = false;
}

export class contactOptionObject {
    key: string;
    value: any;
}
export class DocumentSelected {
    data: any;
    status: DocStatusType;
}
export enum DocStatusType {
    docLoaded = <any>'DocLoaded',
    docPicked = <any>'DocPicked',
    docError = <any>'DocError',
    docCleared = <any>'DocCleared',
    docSizeError = <any>'DocSizeError',
}
export enum WebAnalyticsModel {
    loggedIn = 'LoggedIn',
    notLoggedIn = 'NotLoggedIn',
    vip = '_VIP',
    nonVip = '_nonVIP',
}
